export const ALL = { value: "ALL", key: "followUps.filters.all" };
export const TO_ME = { value: "TO_ME", key: "followUps.filters.toMe" };
export const FROM_ME = { value: "FROM_ME", key: "followUps.filters.fromMe" };

export default [ALL, TO_ME, FROM_ME];



// WEBPACK FOOTER //
// ./src/components/dashboard/follow-ups/list/enums/followUpFilters.js